export enum NonCategoryFilters {
    Classification = "Classification",
    Audience = "Audience",
    CopyrightStatus = "Copyright Status",
    DocumentType = "Document Type",
    Publication = "Publication Status",
    DisseminationControls = "Dissemination Controls",
    Sci = "SCI"
}